import styled from 'styled-components';
import React, { useState } from 'react';
import axios from 'axios';
import { createNewGame } from '../../utils/global';
import fetchConfig from '../../Constants/fetch';

// Stylings
// TODO: IMPLEMENT
const InnerContainer = styled.div`
    width: 520px;
    height: 280px;
    background: ${props => props.theme.colors.white};
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
    text-align: center;
    position: absolute;
    font-family: 'Roboto', sans-serif;
    z-index: 2;
    animation: zoomIn 0.2s ease-in-out;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
const TextContainer = styled.div`
    height: 58%;
`;
const Br = styled.div`
    height: 15%;
`;
const HeaderText = styled.div`
    font-weight: bold;
    font-size: 24px;
    line-height: 50%;
    color: ${props => props.theme.colors.black};
    height: 25%;
`;
const ParagraphText = styled.div`
    font-size: 16px;
    line-height: 135%;
    color: ${props => props.theme.colors.black};
    width: 85%;
    display: inline-table;
`;
const ButtonContainer = styled.button`
    width: 40%;
    height: 77%;
    background: ${props => props.theme.colors.darkGreen};
    border-radius: 4px;
    cursor: pointer;
    border: none;
`;
const ButtonContainerLine = styled.div`
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: space-evenly;
    margin-top: -20px;
`;
const GetStartedButton = styled.div`
    font-weight: bold;
    font-size: 16px;
    line-height: 2.05vh;
    color: ${props => props.theme.colors.white};
    width: 100%;
`;
// TODO: Fix this, this is temporary fix
export default function RestoreGamePopUp({
    show,
    toggleRestoreGamePopup,
    handleLogin,
    userId,
    playerName,
    prevGameId,
    handleRestoreGame,
    gameEventId,
}) {
    const [isClicked, setIsClicked] = useState(false);
    if (show) {
        return (
            <InnerContainer>
                <Br />
                <TextContainer>
                    <HeaderText>Continue Playing</HeaderText>{' '}
                    <ParagraphText>
                        You did not finish your last game.
                        <Br /> Would you like to continue playing where you left off?
                    </ParagraphText>{' '}
                </TextContainer>{' '}
                <ButtonContainerLine>
                    <ButtonContainer
                        onClick={() => {
                            toggleRestoreGamePopup(false);
                            handleRestoreGame(userId, prevGameId, playerName);
                        }}
                    >
                        <GetStartedButton>Yes, Continue</GetStartedButton>{' '}
                    </ButtonContainer>{' '}
                    <ButtonContainer
                        onClick={async () => {
                            toggleRestoreGamePopup(false);
                            setIsClicked(true);

                            // Delete saved game snapshot when starting over
                            try {
                                await axios.delete(
                                    `${fetchConfig.prefix}/game/saved_game/${userId}`,
                                );
                            } catch (error) {
                                console.error('Error deleting saved game:', error);
                                // Continue anyway - deletion failure shouldn't block new game
                            }

                            const newGameResult = await createNewGame(userId, gameEventId); // create new gameId before handleLogin
                            // Check if result is object with gameId or just gameId
                            const gameId = newGameResult.gameId || newGameResult;
                            handleLogin(playerName, userId, gameId);
                        }}
                        disabled={isClicked}
                        style={{ backgroundColor: '#81818c' }}
                    >
                        <GetStartedButton> No, Start over </GetStartedButton>{' '}
                    </ButtonContainer>
                </ButtonContainerLine>{' '}
            </InnerContainer>
        );
    }
    return null;
}
